import { isUsingEnv as t } from "./index.js";
const n = (e) => (r) => e[r] && t(e[r]);
export {
  n as default
};
//# sourceMappingURL=featureFlag.js.map
